import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center items-center px-6 py-20 overflow-hidden" data-id="element-39">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber/5 rounded-full blur-[120px] pointer-events-none" data-id="element-40" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-41">
        <FadeIn delay={0.1} data-id="element-42">
          <p className="text-amber uppercase tracking-[0.2em] text-sm font-semibold mb-6" data-id="element-43">
            El protocolo de 3 días para vaciar la cabeza, dormir bien el domingo
            y entrar al lunes con control real.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-44">
          <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[1.1] text-offwhite mb-8" data-id="element-45">
            EL RESET DE 72 HORAS: <br data-id="element-46" />
            <span className="text-mutedred drop-shadow-[0_0_20px_rgba(196,75,75,0.4)]" data-id="element-47">
              EL DOMINGO A LA NOCHE TE ESTÁ ROBANDO EL LUNES. CORTÁ EL CICLO EN
              72 HORAS.
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-48">
          <p className="text-amber text-base sm:text-lg font-medium mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-49">
            Leé esto una sola vez. Tomate 1 minuto.{' '}
            <br className="hidden sm:block" data-id="element-50" />
            Puede ser lo que cambie todo para vos.
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-51">
          <p className="text-lg sm:text-xl text-offwhite/80 max-w-2xl mx-auto mb-12 font-body font-light leading-relaxed" data-id="element-52">
            Son las 9:15 PM de un domingo. Estás sentado en el sofá con un nudo
            en el estómago que no te deja cenar. Físicamente estás en tu casa,
            pero mentalmente ya estás encadenado a la oficina, repasando
            reuniones, correos y problemas que aún no han pasado.
            <br data-id="element-53" />
            <br data-id="element-54" />
            Te sentís agotado, pero cuando cerrás los ojos, tu cerebro se
            enciende. Estás viviendo en "modo supervivencia" y tu cuerpo está
            pagando el precio.
          </p>
        </FadeIn>
      </div>
    </section>;
}